export default "__VITE_ASSET__xcabJA5D__ 1200w";